var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfoundedAvailablePractitioner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13542_243048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.3H10.6667C11.4 1.3 12 1.885 12 2.6V5.41604C11.5822 5.23351 11.1347 5.10641 10.6667 5.04406V4.55H1.33333V11.7H5.29642C5.46637 12.1701 5.70479 12.6075 5.99963 13H1.33333C0.593333 13 0 12.415 0 11.7L0.00666666 2.6C0.00666666 1.885 0.593333 1.3 1.33333 1.3H2V0H3.33333V1.3H8.66667V0H10V1.3Z",
    fill: "#D31759"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14ZM10.8684 10L12 8.86847L11.1315 8L9.99988 9.13153L8.86852 8.00024L8 8.8687L9.13136 10L8 11.1313L8.86852 11.9998L9.99988 10.8685L11.1315 12L12 11.1315L10.8684 10Z",
    fill: "#D31759"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13542_243048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfoundedAvailablePractitioner);
export default __webpack_public_path__ + "static/media/unfounded-available-practitioner.290762ea6f096a9fd50ad59c585db998.svg";
export { ForwardRef as ReactComponent };